// removed by extract-text-webpack-plugin
module.exports = {"navBarContainer":"GMYTSkFppv_hC5JN-jYkZ","navBarItem":"_1JkRqkEURWBYgobTr2g_z1","navBarContainerIsOpen":"_1J5JUN4W2DciVki6OFC9R7","nav":"_2eFWC9hpEkKRALDGTk2_32","navIsOpen":"_3VRuBvmXN750uv-ZtqdHfD","link":"_1ASYSMfDn_jXeTiQy7YBe4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Nav/styles.css
// module id = 297
// module chunks = 0